module.exports = __webpack_public_path__ + "img/canary_wharf_2k.68d6010c.png";